import AxiosInstance from "../components/utils/AxiosInstance";

const getCentralCallPath = () => {
  const isDevelopment = process.env.NODE_ENV === "development";
  return `${isDevelopment ? "" : "travel/"}central/centralcall/CallReqWithHeader`;
};

const API = {
  async CallRequestWithHeader(params) {
    try {
      const response = await AxiosInstance.post(
        getCentralCallPath(),
        params,
      );
      return response.data;
    } catch (error) {
      console.error({ error });
      return error.response;
    }
  },
};

export default API;
